/* RKC newsletter popup — timing and memory only. Opening, closing, focus trap
   and ESC come from Dawn's <modal-dialog> (assets/global.js). */
(() => {
  const STORAGE_KEY = 'rkc-newsletter-popup';
  const DAY_MS = 86400000;
  const popup = document.getElementById('RkcNewsletterPopup');
  if (!popup) return;

  const formId = popup.dataset.formId;
  const delayMs = Number(popup.dataset.delay) * 1000;
  const dismissMs = Number(popup.dataset.dismissDays) * DAY_MS;

  const readState = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (error) {
      return {};
    }
  };
  const writeState = (patch) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readState(), ...patch }));
    } catch (error) {
      // Storage unavailable (private mode): the popup simply shows again next visit.
    }
  };

  const show = () => customElements.whenDefined('modal-dialog').then(() => popup.show());

  // Never stack on Shopify's cookie banner: while it is on screen, wait for the
  // visitor's decision (Shopify fires `visitorConsentCollected` and removes the banner).
  const cookieBanner = () => document.getElementById('shopify-pc__banner');
  const open = () => {
    const banner = cookieBanner();
    if (!banner || banner.getClientRects().length === 0) {
      show();
      return;
    }
    let done = false;
    const showOnce = () => {
      if (done) return;
      done = true;
      observer.disconnect();
      show();
    };
    const observer = new MutationObserver(() => {
      const current = cookieBanner();
      if (!current || current.getClientRects().length === 0) showOnce();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    document.addEventListener('visitorConsentCollected', showOnce, { once: true });
  };

  // Dawn only hears ESC while focus is inside the modal; cover focus lost to the cookie banner.
  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape' && popup.hasAttribute('open')) popup.hide();
  });

  const copyButton = popup.querySelector('[data-copy]');
  if (copyButton && navigator.clipboard) {
    copyButton.addEventListener('click', () => {
      navigator.clipboard.writeText(copyButton.dataset.copy).then(() => {
        copyButton.textContent = copyButton.dataset.copiedLabel;
      });
    });
  }

  // Theme editor: preview on select, never on a timer.
  if (window.Shopify && window.Shopify.designMode) {
    const isThisSection = (event) => event.detail.sectionId === popup.dataset.sectionId;
    document.addEventListener('shopify:section:select', (event) => {
      if (isThisSection(event)) open();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (isThisSection(event)) popup.hide();
    });
    return;
  }

  // Any close (X, ESC, backdrop) removes Dawn's `open` attribute: remember it.
  new MutationObserver(() => {
    if (!popup.hasAttribute('open')) writeState({ dismissedAt: Date.now() });
  }).observe(popup, { attributes: true, attributeFilter: ['open'] });

  const posted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
  if (posted) writeState({ subscribed: true });

  // Back from our own form (success or validation error): show it straight away.
  if (window.location.hash === `#${formId}`) {
    // After `load`, so the browser's fragment scroll can't steal focus from the dialog.
    if (document.readyState === 'complete') show();
    else window.addEventListener('load', show, { once: true });
    return;
  }

  const state = readState();
  if (state.subscribed) return;
  if (state.dismissedAt && Date.now() - state.dismissedAt < dismissMs) return;
  setTimeout(open, delayMs);
})();
